module.exports = __webpack_public_path__ + "img/product_8.817d5bc.jpg";